// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.pbi-container[data-v-1742f6e3] {\n  height: 85vh;\n}\n", ""]);
// Exports
module.exports = exports;
